module.exports = __webpack_public_path__ + "static/media/SZ.b8b28bdb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/SZ.svg
// module id = 368
// module chunks = 0